import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { validateSession } from '../hooks/useUserValidityCheck';

// Intervallo minimo tra due validate triggerati da click (ms)
const CLICK_THROTTLE_MS = 10_000;

/**
 * Esegue validateSession():
 * - Ad ogni cambio di route (pathname)
 * - Ad ogni click utente (throttled a 10s) — copre card dashboard senza navigazione
 *
 * Va montato dentro <Router> ma fuori da <Routes>.
 */
const RouteValidator: React.FC = () => {
  const location = useLocation();
  const lastClickCheck = useRef<number>(0);

  // Cambio route → validate immediato
  useEffect(() => {
    validateSession();
  }, [location.pathname]);

  // Click su qualsiasi elemento → validate throttled
  useEffect(() => {
    const handleClick = () => {
      const now = Date.now();
      if (now - lastClickCheck.current >= CLICK_THROTTLE_MS) {
        lastClickCheck.current = now;
        validateSession();
      }
    };
    window.addEventListener('click', handleClick, { capture: true });
    return () => window.removeEventListener('click', handleClick, { capture: true });
  }, []);

  return null;
};

export default RouteValidator;
